angular.module('utils')
	.factory('mainUtils', ['$sce', function ($sce) {
		const browserInfo = {};

		checkBrowser();

		function checkBrowser() {
			var	mobileCheck = false,
				mobileAndTabletCheck = false,
				osName = 'Unknown',
				nAgt = window.navigator.userAgent.toLowerCase(),
				browserName = navigator.appName,
				fullVersion = '' + parseFloat(navigator.appVersion),
				majorVersion = parseInt(navigator.appVersion, 10),
				nameOffset, verOffset, ix;

			(function (a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
					mobileCheck = true;
				}
			})(navigator.userAgent || navigator.vendor || window.opera);

			(function (a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
					mobileAndTabletCheck = true;
				}
			})(navigator.userAgent || navigator.vendor || window.opera);

			if (navigator.appVersion.indexOf('Win') !== -1) {
				osName = 'windows';
			} else if (navigator.appVersion.indexOf('Mac') !== -1) {
				osName = 'macos';
			} else if (navigator.appVersion.indexOf('X11') !== -1) {
				osName = 'unix';
			} else if (navigator.appVersion.indexOf('Linux') !== -1) {
				osName = 'linux';
			} else if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
				osName = 'iOS';
			} else if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) { // iPadOS
				osName = 'iOS';
				mobileAndTabletCheck = true;
			}

			var isIpadOs = window.AuthenticatorAssertionResponse === undefined &&
				window.AuthenticatorAttestationResponse === undefined &&
				window.AuthenticatorResponse === undefined &&
				window.Credential === undefined &&
				window.CredentialsContainer === undefined &&
				window.DeviceMotionEvent !== undefined &&
				window.DeviceOrientationEvent !== undefined &&
				navigator.maxTouchPoints === 5 &&
				navigator.plugins.length === 0 &&
				navigator.platform !== 'iPhone';

			if (isIpadOs) {
				osName = 'iPadOS';
				mobileAndTabletCheck = true;
			}

			var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
			// Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
			var isFirefox = typeof InstallTrigger !== 'undefined';   // Firefox 1.0+
			var isSafari = nAgt.indexOf('safari') !== -1 && nAgt.indexOf('chrome') < 0;
			// At least Safari 3+: "[object HTMLElementConstructor]"
			var isChrome = nAgt.indexOf('safari') !== -1 && nAgt.indexOf('chrome') > -1 && !isOpera; // Chrome 1+
			var isIE = /*@cc_on!@*/false || !!document.documentMode; // At least IE6


			// In Opera, the true version is after "Opera" or after "Version"
			if (isOpera) {
				browserName = 'opera';
				fullVersion = nAgt.substring(verOffset + 6);
				if ((verOffset = nAgt.indexOf('version')) !== -1) {
					fullVersion = nAgt.substring(verOffset + 8);
				}
			}
			// In MSIE, the true version is after "MSIE" in userAgent
			else if (isIE) {
				browserName = 'ie';
				fullVersion = nAgt.substring(verOffset + 5);
			}
			// In Chrome, the true version is after "Chrome"
			else if (isChrome) {
				browserName = 'chrome';
				fullVersion = nAgt.substring(verOffset + 7);
			}
			// In Safari, the true version is after "Safari" or after "Version"
			else if (isSafari) {
				browserName = 'safari';
				fullVersion = nAgt.substring(verOffset + 7);
				if ((verOffset = nAgt.indexOf('version')) !== -1) {
					fullVersion = nAgt.substring(verOffset + 8);
				}
			}
			// In Firefox, the true version is after "Firefox"
			else if (isFirefox) {
				browserName = 'firefox';
				fullVersion = nAgt.substring(verOffset + 8);
			}
			// In most other browsers, "name/version" is at the end of userAgent
			else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
				(verOffset = nAgt.lastIndexOf('/'))) {
				browserName = nAgt.substring(nameOffset, verOffset);
				fullVersion = nAgt.substring(verOffset + 1);
				if (browserName.toLowerCase() === browserName.toUpperCase()) {
					browserName = navigator.appName;
				}
			}
			// trim the fullVersion string at semicolon/space if present
			if ((ix = fullVersion.indexOf(';')) !== -1) {
				fullVersion = fullVersion.substring(0, ix);
			}
			if ((ix = fullVersion.indexOf(' ')) !== -1) {
				fullVersion = fullVersion.substring(0, ix);
			}

			majorVersion = parseInt('' + fullVersion, 10);
			if (isNaN(majorVersion)) {
				fullVersion = '' + parseFloat(navigator.appVersion);
				majorVersion = parseInt(navigator.appVersion, 10);
			}

			Object.assign(browserInfo, {
				isMobile: mobileCheck,
				isMobileAndTablet: mobileAndTabletCheck,
				osName,
				browserName,
				browserVer: fullVersion
			});
		}

		function getBrowserInfo() {
			return browserInfo;
		}

		function createUrl(path, params) {
			var paramsList = [];

			_.each(params, function (param, key) {
				paramsList.push(key + '=' + encodeURIComponent(param));
			});
			if (paramsList.length) {
				return path + '?' + paramsList.join('&');
			}
			return path;
		}

		function trustSrc(src) {
			return $sce.trustAsResourceUrl(src);
		}

		function convertDate(date, sep) {
			if (!(typeof date === 'string' || date instanceof String)) {
				return false;
			}
			var match = date.match(/[\/\s\.\_\-]{0,4}(\d+)[\/\s\.\_\-]{1,6}(\d+)[\/\s\.\_\-]{1,6}(\d{1,4})[\/\s\.\_\-]{0,5}/);
			if (match !== null && match.length === 4) {
				date = [match[1], match[2], match[3]];
				if (date[0].length === 4 || date[0] > 31) {
					date = date.reverse();
				}
				_.each(date, function (n, i) {
					if (n.length === 1) {
						date[i] = '0' + n;
					}
				});
				if (date[2].length < 4) {
					if (date[2].substring(0, 2) !== '19') {
						date[2] = '19' + date[2].substring(0, 2);
					}
				}
				if (date[1] > 12 && date[0] <= 12) {
					var x = date[0];
					date[0] = date[1];
					date[1] = x;
				}
				var d = new Date(date.reverse().join('-'));
				if (!(_.isDate(d) && parseInt(d.getDate()) === parseInt(date[2]))) {
					return false;
				}
				return date.reverse().join(sep);
			}
			return false;
		}

		return {
			getBrowserInfo,
			createUrl,
			trustSrc,
			convertDate 
		};
	}]);